import React from 'react';
import { useLocation } from 'react-router-dom';

type Props = { pob: { _id: string; firstName: string; lastName: string } };

/** Identify a linked record by its ID, never by a potentially duplicated name. */
export default function PobName({ pob }: Props) {
    const { search } = useLocation();
    const highlighted = new URLSearchParams(search).get('highlightPobID') === pob._id;
    const name = `${pob.lastName}, ${pob.firstName}`;

    return highlighted ? (
        <mark className="mc-pulse-highlight mc-qm-highlighted-pob" title={`POB ID: ${pob._id}`}>
            {name} <small>Target record</small>
        </mark>
    ) : <span>{name}</span>;
}
